import React from 'react';
import { Link } from 'react-router-dom';
import { Flex, Box, Image } from '@mantine/core';
import { HamburgerMenu } from './partials/HamburgerMenu';
import { LanguageSelect } from './partials/LanguageSelect';
import { useAuth } from '@/providers/AuthProvider';
import LogoSrc from '@/assets/images/logo.png';
import styles from './Navbar.module.scss';

const baseSlug = 'sidebar.';

export const Navbar: React.FC = () => {
	const user = useAuth().user;

	return (
		<Box
			component="nav"
			id="navbar"
			className={styles.navbar}
			px={{ base: 'md', md: 'lg' }}
		>
			<Box>
				<Link to="/">
					<Image src={LogoSrc} h={50} />
				</Link>
			</Box>
			<Flex gap="lg">
				<LanguageSelect />
				{!!user && <HamburgerMenu baseSlug={baseSlug} />}
			</Flex>
		</Box>
	);
};
